import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import FilePreviewCard from "components/UpStyled/FilePreviewCard";
import SuiTypography from "components/SuiTypography";
import SuiBox from "components/SuiBox";

const MAX_FILE_SIZE = 40; //MB

function DropZone({
  files,
  setfiles,
  options = {},
  handleOnChange = () => {},
  onFileClick = () => {},
  hintStyle = {},
  style = {},
  fileCardStyle = {},
}) {
  const handleDropRejected = (files) => {
    let message = "";
    let fileName = "";
    for (let i = 0; i < files.length; i++) {
      const { errors, file } = files[i];
      if (errors) {
        fileName = file.name;
        for (let j = 0; j < errors.length; j++) {
          if (errors[j]?.code == "file-too-large") {
            message = `File:${fileName} is larger than ${MAX_FILE_SIZE}MB!`;
          } else {
            message = errors[j]?.message;
          }
        }
      }
    }
    if (message) {
      toast.error(message);
    }
  };

  const handleOnDrop = (acceptedFiles) => {
    let newFiles = [
      ...files,
      ...acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      ),
    ];
    setfiles(newFiles);
    handleOnChange(newFiles);
  };

  const handleDeleteFile = (path) => {
    const newFiles = files.filter((x) => x != path && x.path != path && x.url != path);
    setfiles([...newFiles]);
    handleOnChange([...newFiles]);
  };

  if (!options.onDropRejected) options.onDropRejected = handleDropRejected;
  if (!options.onDrop) options.onDrop = handleOnDrop;
  if (!options.maxSize) options.maxSize = MAX_FILE_SIZE * 1024 * 1024;
  if (!options.noKeyboard) options.noKeyboard = true;
  if (!options.accept) options.accept = {};

  const { getRootProps, getInputProps } = useDropzone({ ...options });
  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    //return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, []);
  return (
    <section style={{ width: "100%" }}>
      <div
        {...getRootProps({ className: "dropzone cursor-pointer z-2" })}
        style={{
          border: "2px dashed gray",
          borderRadius: "15px",
          margin: "0 4px",
          width: "100%",
          height: "100%",
          overflowX: "auto",
          overflowY: "hidden",
          ...style,
        }}
      >
        <SuiBox display="flex" justifyContent="center" sx={{ margin: "auto" }}>
          <input {...getInputProps()} />
          <SuiTypography variant="text" fontWeight="medium" color="secondary" {...hintStyle}>
            Drag and drop files here or click the space to select files
          </SuiTypography>
        </SuiBox>
        <FilePreviewCard
          files={files}
          setfiles={setfiles}
          handleDelete={handleDeleteFile}
          onFileClick={(file) => {
            onFileClick(file);
          }}
          fileCardStyle={fileCardStyle}
        />
      </div>
    </section>
  );
}
export default DropZone;
